import styled from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

export const Wrapper = styled.div`
  position: relative;
  cursor: pointer;
`;

export const VideoWrapper = styled.div`
  position: relative;
  width: 606px;
  height: 269px;
  margin: 0 auto;

  ${({ theme }) => theme.media.mobile} {
    width: 100%;
    height: 0;
    padding-bottom: 58%;
  }
`;

export const Video = styled.video`
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

export const MessageWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  min-width: 224px;
  padding: 16px 32px;
  background-color: #fff;
  border: 1px solid ${({ theme }) => theme.colors.gray400};
  border-radius: 4px;
`;

export const Message = styled.div`
  margin-bottom: 8px;
  ${getFontStyle('midium150_C1')};
`;
